import React, { useState } from "react";
import { Option, Select } from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api/api";
import { store } from "../store";
import { login } from "../features/auth/Auth";
import { countriess } from "../utils/country";
import { encrypt } from "../utils/CryptData";
import { logoMoide } from "../assets/images";

function SignUp() {
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    contact: "",
    email: "",
    city: "",
    address: "",
    password: "",
    confirmPassword: "",
  });

  const [checkPwd1, setCheckPawd1] = useState(false);
  const [checkPwd2, setCheckPawd2] = useState(false);
  const navigate = useNavigate();

  const handleCheck = (checker) => {
    if (checker === "pwd") {
      setCheckPawd1(!checkPwd1);
    }
    if (checker === "cpwd") {
      setCheckPawd2(!checkPwd2);
    }
  };

  const isValidate = () => {
    let isProceed = true;
    let errorMessage = "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10,}$/;

    if (formData.firstName.length < 2) {
      isProceed = false;
      errorMessage = "Veuillez saisir un nom valide (minimum 2 caractères).";
    } else if (formData.lastName.length < 2) {
      isProceed = false;
      errorMessage = "Veuillez saisir un prénom valide (minimum 2 caractères).";
    } else if (!phoneRegex.test(formData.contact.replace(/\D/g, ''))) {
      isProceed = false;
      errorMessage = "Veuillez saisir un numéro de téléphone valide.";
    } else if (!emailRegex.test(formData.email)) {
      isProceed = false;
      errorMessage = "Veuillez saisir une adresse e-mail valide.";
    } else if (!formData.city) {
      isProceed = false;
      errorMessage = "Veuillez sélectionner une ville.";
    } else if (!formData.address || formData.address.length < 5) {
      isProceed = false;
      errorMessage = "Veuillez saisir une adresse complète (minimum 5 caractères).";
    } else if (formData.password.length < 6) {
      isProceed = false;
      errorMessage = "Le mot de passe doit contenir au minimum 6 caractères.";
    } else if (formData.password !== formData.confirmPassword) {
      isProceed = false;
      errorMessage = "Les mots de passe ne correspondent pas.";
    }

    if (!isProceed) toast.error(errorMessage);
    return isProceed;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isValidate()) {
      try {
        const res = await api.post("/auths/register", formData);
        localStorage.setItem("dus", encrypt(JSON.stringify(res.data)));
        store.dispatch(login());
        navigate(-1);
        toast.success("Inscription réussie!");
      } catch (error) {
        toast.error("Échec de l'inscription. Veuillez réessayer.");
      }
    }
  };

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-offset="200"
      className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
    >
      {/* Form Section */}
      <div className="flex flex-col min-h-screen items-center justify-center px-4 sm:px-2 lg:px-4 bg-white">
        <div className="w-full max-w-xl p-8 rounded-lg">
          <h2 className="text-center text-3xl font-bold text-gray-900 mb-2">
            Inscription
          </h2>
          <p className="text-center text-gray-600 text-sm mb-8">
            Créez votre compte en quelques étapes simples
          </p>

          <form
            className="grid grid-cols-1 sm:grid-cols-2 gap-6"
            onSubmit={handleSubmit}
          >
            {/* First Name */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Nom</span>
              <input
                type="text"
                placeholder="Ex: Martin"
                className="input input-bordered w-full rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                value={formData.firstName}
                onChange={(e) =>
                  setFormData({ ...formData, firstName: e.target.value })
                }
                required
              />
            </label>

            {/* Last Name */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Prénom(s)</span>
              <input
                type="text"
                placeholder="Ex: Jean"
                className="input input-bordered w-full rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                value={formData.lastName}
                onChange={(e) =>
                  setFormData({ ...formData, lastName: e.target.value })
                }
                required
              />
            </label>

            {/* Contact */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Téléphone</span>
              <input
                type="tel"
                placeholder="+225 01 23 45 67 89"
                className="input input-bordered w-full rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                value={formData.contact}
                onChange={(e) =>
                  setFormData({ ...formData, contact: e.target.value })
                }
                required
              />
            </label>

            {/* Email */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Adresse e-mail</span>
              <input
                type="email"
                placeholder="exemple@email.com"
                className="input input-bordered w-full rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </label>

            {/* City Dropdown */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Ville</span>
              <Select
                id="city"
                name="city"
                placeholder="Sélectionnez une ville"
                className="input input-bordered w-full bg-white rounded-md focus:ring-2 focus:ring-green-600"
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e })}
              >
                {countriess.map((item) => (
                  <Option key={item.code} value={item.capital}>
                    {item.capital}
                  </Option>
                ))}
              </Select>
            </label>

            {/* Address */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Adresse complète</span>
              <input
                type="text"
                placeholder="Ex: 123 Rue Principale, Apt 45"
                className="input input-bordered w-full rounded-md focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                required
              />
            </label>

            {/* Password */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Mot de passe</span>
              <div className="relative">
                <input
                  type={checkPwd1 ? "text" : "password"}
                  placeholder="Minimum 6 caractères"
                  className="input input-bordered w-full rounded-md pr-10 focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  required
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xl hover:opacity-70 transition"
                  onClick={() => handleCheck("pwd")}
                >
                  {checkPwd1 ? "👁️" : "🙈"}
                </button>
              </div>
            </label>

            {/* Confirm Password */}
            <label className="form-control w-full">
              <span className="label-text font-semibold text-gray-700">Confirmation mot de passe</span>
              <div className="relative">
                <input
                  type={checkPwd2 ? "text" : "password"}
                  placeholder="Répétez votre mot de passe"
                  className="input input-bordered w-full rounded-md pr-10 focus:outline-none focus:ring-2 focus:ring-green-600 transition"
                  value={formData.confirmPassword}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      confirmPassword: e.target.value,
                    })
                  }
                  required
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xl hover:opacity-70 transition"
                  onClick={() => handleCheck("cpwd")}
                >
                  {checkPwd2 ? "👁️" : "🙈"}
                </button>
              </div>
            </label>

            {/* Submit Button */}
            <div className="sm:col-span-2 flex justify-center mt-6">
              <button
                type="submit"
                className="w-7/12  bg-primary hover:bg-primary/90 text-white font-medium text-white p-3 rounded-md transition duration-200 "
              >
                S'inscrire
              </button>
            </div>
          </form>

          {/* Login Redirect */}
          <p className="mt-6 text-center text-sm text-gray-600">
            Vous avez déjà un compte ?{" "}
            <Link
              to="/login"
              className="font-semibold text-indigo-600 hover:text-indigo-700 transition"
            >
              Connectez-vous
            </Link>
          </p>
        </div>
      </div>

      {/* Image Section */}
      <div className="hidden md:flex justify-center items-center p-2">
        <img
          className="mx-auto w-9/12 h-auto"
          src={logoMoide}
          alt="Moide Ferme"
        />
      </div>
    </div>
  );
}

export default SignUp;
